import { Users, User, Clock, DollarSign, UserPlus, TrendingUp, IdCard, Megaphone } from 'lucide-react';
export const equipo = [
  { nameKey: 'nav.people', icon: IdCard, zone: 'work', beta: true, subItems: [
    { nameKey: 'nav.team', pageName: 'RRHHEmpleados', icon: Users, permission: 'hr.view', descriptionKey: 'navigation.descriptions.team', shortcuts: [
      { nameKey: 'nav.skills', params: { tab: 'skills' } },
    ] },
    { nameKey: 'nav.time', pageName: 'TimesheetManager', icon: Clock, descriptionKey: 'navigation.descriptions.time', shortcuts: [
      { nameKey: 'nav.absences', params: { tab: 'ausencias' } },
      { nameKey: 'nav.time_tracking', params: { tab: 'control' } },
      { nameKey: 'nav.timesheets', params: { tab: 'timesheets' } },
    ] },
    { nameKey: 'nav.compensation', pageName: 'Nominas', icon: DollarSign, permission: 'payroll.view', descriptionKey: 'navigation.descriptions.payroll' },
    { nameKey: 'navigation.lifecycle', pageName: 'Onboarding', icon: UserPlus, descriptionKey: 'navigation.descriptions.lifecycle', shortcuts: [
      { nameKey: 'nav.contracts', params: { tab: 'contratos' }, permission: 'hr.view' },
    ] },
    { nameKey: 'nav.communications', pageName: 'Onboarding', id: 'HRCommunications', path: '/onboarding?tab=comunicaciones', icon: Megaphone, descriptionKey: 'navigation.descriptions.communications' },
    { nameKey: 'nav.hr_reports', pageName: 'InformesRRHH', icon: TrendingUp, permission: 'hr.view', descriptionKey: 'navigation.descriptions.hr_reports' },
  ] },
];
// Personal access belongs beside the account/tenant context, not in the
// manager's employee menu. Sidebar and the account menu share this destination.
export const personal = [
  { nameKey: 'nav.my_zone', pageName: 'PortalEmpleado', icon: User, zone: 'personal' },
];
export const nav = [...equipo, ...personal];
